const link = {
	attrs: {
		href: {},
		resourcePath: {},
		hash: { default: "" },
		isFile: { default: false },
		title: { default: null },
	},
	inclusive: false,
};

export default link;
